import {Component, Inject, OnInit} from '@angular/core';
import {
  FormControl,
  Validators
} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PaymentDTO} from 'src/app/modules/clm/models/payment/PaymentDTO';
import {KeycloakService} from 'keycloak-angular';
import {PaymentsService} from 'src/app/modules/clm/services/payments.service';
import {SharedService} from '../../../../common/services/shared-service';
import {UserAuthorisationService} from 'src/app/modules/common/services/user-authorisation.service';
import {take} from 'rxjs';

@Component({
  selector: 'app-payment-reference-dialog',
  templateUrl: './update-payment-reference-dialog.component.html',
  styleUrls: [
    './update-payment-reference-dialog.component.scss',
    '../../../../../../styles/global/_dialog-styles.scss'
  ]
})
export class UpdatePaymentReferenceDialogComponent implements OnInit {

  paymentIDFormControl: FormControl;
  paymentReferenceFormControl: FormControl;
  completionDateFormControl: FormControl;
  userFirstLastName = '';
  paymentDTO: PaymentDTO = null;
  paymentExecutionDate: Date;

  constructor(
    private keycloakService: KeycloakService,
    private paymentService: PaymentsService,
    public dialogRef: MatDialogRef<UpdatePaymentReferenceDialogComponent>,
    private sharedService: SharedService,
    private userAuthorisationService: UserAuthorisationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.paymentDTO = data;
    this.paymentExecutionDate = this.paymentDTO.paymentExecutionDate != null ? new Date(this.paymentDTO.paymentExecutionDate) : null;
    const today = new Date();
    const minDate = this.paymentExecutionDate != null && this.paymentExecutionDate.getTime() > today.getTime() ? this.paymentExecutionDate : today;
    const defaultDate = this.paymentDTO.paymentCompletionDate != null ? new Date(this.paymentDTO.paymentCompletionDate) : minDate;
    this.paymentIDFormControl = new FormControl(this.paymentDTO.paymentId, Validators.required);
    this.paymentReferenceFormControl = new FormControl(this.paymentDTO.paymentReference, Validators.required);
    this.completionDateFormControl = new FormControl(defaultDate, Validators.required);
  }

  get isAuthorised(): boolean {
    return this.userAuthorisationService.hasRoleFinancialManager();
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
    this.sharedService.getHelpInfo('Payment');
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  savePaymentReference() {
    const payment = {
      created: this.paymentDTO.created,
      createdBy: this.paymentDTO.createdBy,
      updated: new Date().getTime(),
      updatedBy: this.userFirstLastName,
      paymentId: this.paymentDTO.paymentId,
      paymentReference: this.paymentReferenceFormControl.value,
      bankAccountNumber: this.paymentDTO.bankAccountNumber,
      isActive: this.paymentDTO.isActive,
      paymentExecutionDate: this.paymentDTO.paymentExecutionDate,
      paymentCompletionDate: new Date(this.completionDateFormControl.value),
      paymentType: this.paymentDTO.paymentType
    };

    this.paymentService.savePayment(payment)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.sharedService.openSnackBar('Payment reference updated successfully.', 'Dismiss');
          this.dialogRef.close();
        },
        error: (errorResponse) => this.sharedService.openSnackBar(errorResponse.error.businessMessage, 'Dismiss')
      });
  }  

  getInfoTooltip(inputName: string) {
    return this.sharedService.getInfoTooltip(inputName);
  }

  isSaveDisabled(): boolean {
    return !this.paymentReferenceFormControl.value || this.paymentReferenceFormControl.value === '' || !this.isAuthorised;
  }

}
